import { FC, useEffect, useRef, useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

type Props = {
  src: string;
  isPreview: boolean;
};

export const MediaPreviewVideo: FC<Props> = ({ src, isPreview }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const [isMediaLoaded, setIsMediaLoaded] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(false);

  const handleMediaLoaded = () => setIsMediaLoaded(true);

  const onPlayClick = (e: React.MouseEvent<HTMLVideoElement>) => {
    if (showPlayButton) {
      e.stopPropagation();
      const video = videoRef.current;
      if (!video) return;
      video.play();
      setShowPlayButton(false);
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isPreview) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setShowPlayButton(true);
        });
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }, [isPreview]);

  return (
    <>
      {!isMediaLoaded && (
        <div className={styles.mediaLoader}>
          <BeatLoader color="white" loading={true} />
        </div>
      )}
      {showPlayButton && <Icon className={styles.playIcon} name="play" />}
      <video
        playsInline
        preload="metadata"
        ref={videoRef}
        src={src}
        loop={true}
        onClick={onPlayClick}
        onPlay={() => {
          setShowPlayButton(false);
        }}
        onPause={() => {
          setShowPlayButton(true);
        }}
        onLoadedData={handleMediaLoaded}
        className={styles.media}
      />
    </>
  );
};
